import React from "react";
import translate from "../../constants/translations";

interface ConversationStatusIndicatorProps {
	cultureCode: string;
	isClosed: boolean;
	hasOneOrMoreUnseenMessages: boolean;
}

export default function ConversationStatusIndicator({
	cultureCode,
	isClosed,
	hasOneOrMoreUnseenMessages,
}: ConversationStatusIndicatorProps) {
	if (hasOneOrMoreUnseenMessages) {
		return (
			<span
				id="new-messages-notification"
				className="mypages-offers-messages__new"
			>
				{translate(cultureCode, "OneOrMoreNewMessages")}
			</span>
		);
	}

	if (isClosed) {
		return (
			<span
				id="closed-conversation-notification"
				className="if font family sans medium-italic mypages-notification-closed"
			>
				{translate(cultureCode, "ConversationClosedStatus")}
			</span>
		);
	}

	return null;
}
